import { EChartMatrixPoint } from '../interfaces';
import { EChartPrepareDataContext } from './echart-prepare-data-context.model';

export abstract class PrepareData {
    abstract prepareData(context: EChartPrepareDataContext): Array<EChartMatrixPoint>;
}
